import { Injectable } from '@angular/core';

@Injectable()
export class EguardNavbarVerticalService
{
    navBarRef;

    constructor()
    {
    }

    setNavBar(ref)
    {
        this.navBarRef = ref;
    }

    getNavBar()
    {
        return this.navBarRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/navbar/vertical/navbar-vertical.service.ts